import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "@/components/shared";
import { useAuth } from "@/context/AuthContext";

const links = [
  ["How It Works", "/how-it-works"],
  ["Pricing", "/pricing"],
  ["Features", "/features"],
  ["Security", "/security"],
  ["Proxmox Backup", "/proxmox-backup"],
  ["MSP", "/msp"],
  ["Docs", "/docs"],
  ["Status", "/status"],
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const nav = useNavigate();
  const { user } = useAuth();

  return (
    <header className="sticky top-0 z-50 border-b border-slate-800/80 bg-[#06080D]/85 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3.5 sm:px-6 lg:px-8">
        <div className="flex items-center gap-8">
          <Logo />
          <nav className="hidden items-center gap-1 xl:flex">
            {links.map(([label, href]) => (
              <Link key={href} to={href} data-testid={`nav-${href.slice(1)}`}
                className={`rounded-md px-3 py-1.5 text-sm transition-colors ${pathname === href ? "text-cyan-300" : "text-slate-400 hover:text-slate-100"}`}>
                {label}
              </Link>
            ))}
          </nav>
        </div>
        <div className="hidden items-center gap-3 md:flex">
          <Link to={user ? "/app/dashboard" : "/login"} data-testid="nav-login"
            className="text-sm text-slate-300 hover:text-white">{user ? "Dashboard" : "Login"}</Link>
          <button onClick={() => nav(user ? "/app/deploy" : "/signup")} data-testid="nav-cta"
            className="rounded-lg bg-cyan-400 px-4 py-2 text-sm font-semibold text-[#06080D] transition-all hover:bg-cyan-300 hover:shadow-[0_0_20px_-4px_rgba(0,229,255,0.6)]">
            Deploy My Backup Server
          </button>
        </div>
        <button className="md:hidden text-slate-200" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="border-t border-slate-800 bg-[#06080D] px-4 py-3 md:hidden">
          {links.map(([label, href]) => (
            <Link key={href} to={href} onClick={() => setOpen(false)}
              className="block py-2 text-sm text-slate-300">{label}</Link>
          ))}
          <div className="mt-2 flex gap-2">
            <Link to={user ? "/app/dashboard" : "/login"} className="flex-1 rounded-lg border border-slate-700 py-2 text-center text-sm text-slate-200">{user ? "Dashboard" : "Login"}</Link>
            <Link to={user ? "/app/deploy" : "/signup"} className="flex-1 rounded-lg bg-cyan-400 py-2 text-center text-sm font-semibold text-[#06080D]">Deploy</Link>
          </div>
        </div>
      )}
    </header>
  );
}
